import React from 'react';
import MenuMain from '../../MenuMain';
import { FormCampanha } from '../../components/FormCampanha';
import { AppFooter } from '../../AppFooter';


export default function CadastrarCampanhaPage() {

  const defaultValues = {
    'nome': '',
    'dataInicio': '',
    'dataFim': '',
    'dataEntrega': '',
    'muda': '',
    'ativo': false,
    'qtde_mudas_rural': 0,
    'qtde_mudas_urbana': 0,
    'endereco': '',
    'validarEnderecoPessoa' : false,
  }

  return (
    <div>
      <MenuMain>
         <FormCampanha
          defaultValues={defaultValues}
        />
      </MenuMain>
      <AppFooter />
    </div>
  );
}

